import React, { memo } from 'react';

const PermissionsAdvancedSearch = () => {
  return <></>;
};

export default memo(PermissionsAdvancedSearch);
